import { emailTemplateSchema } from "@redotech/redo-marketing-templates-common/email-template";
import * as z from "zod";

export const getEmailTemplatesForTeam = {
  name: "getEmailTemplatesForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(emailTemplateSchema),
};
